Object.defineProperty(exports, "__esModule", { value: true });
exports.selfTrReset = exports.selfThReset = exports.selfTdReset = exports.selfTableReset = void 0;
exports.selfTableReset = {
    ncss: {
        boxSizing: 'border-box',
        fontFamily: 'text',
    },
};
exports.selfTdReset = {
    ncss: {
        boxSizing: 'border-box',
        fontFamily: 'text',
    },
};
exports.selfThReset = {
    ncss: {
        boxSizing: 'border-box',
        fontFamily: 'text',
    },
};
exports.selfTrReset = {
    ncss: {
        boxSizing: 'border-box',
        fontFamily: 'text',
    },
};
//# sourceMappingURL=self-table-reset.js.map